/* ══════════════════════════════════════════════════════════════════
   联系页的表单。这份 JS 只做三件锦上添花的事 ——
   **没有它，表单照样填得完、交得出去。**

   （上传不在这里：它是**表单套件的一件**，三张表共用，住在
   `component-upload.js`。那一块的存在本身就取决于 JS，所以它由 section
   设置控制开关、端点没配就不渲染 —— 和这三件的性质不一样。）

   1. 把选中的 reason 写到 `.eb-ctf` 的 `data-reason` 上。
      换脸本身是 CSS 干的（`:has()`），这一条是**第二条独立的路**：
      `:has` 整条选择器列表一旦不被支持会被整条丢掉，而那会让
      三组字段永远不出现。两条规则各写各的，谁挂了都不影响另一条。

   2. **把没显示的那两组 `disabled` 掉。** CSS 隐藏的字段照样会提交，
      不禁用就会在邮件里多出几行空字段。（同一条规矩在这一节里出现两次：
      正文那个 textarea 之所以只有一个，也是因为它。）

   3. 首行那三张卡上的「用表单」：把对应的 reason 选上再滚过去。
      按钮本身是真锚点（`href="#write"`），所以没有这份 JS 时
      点了照样跳到表单那一节，只是不预选。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function sync(form) {
    var on = form.querySelector('input[name="contact[Reason]"]:checked');
    if (!on) return;
    var reason = on.id.replace('ct-', '');
    form.dataset.reason = reason;

    form.querySelectorAll('[data-when]').forEach(function (group) {
      var off = group.dataset.when !== reason;
      group.querySelectorAll('input, select, textarea').forEach(function (field) {
        field.disabled = off;
      });
    });

    /* 正文的提示语跟着 reason 换。没有对应的提示就保持原样 ——
       清空 placeholder 会让这一格看起来像坏了。 */
    var body = form.querySelector('[data-ct-body]');
    if (body) {
      var ph = body.dataset['ph' + reason.charAt(0).toUpperCase() + reason.slice(1)];
      if (ph) body.placeholder = ph;
    }
  }

  function init() {
    document.querySelectorAll('[data-ct-form]').forEach(sync);
  }

  document.addEventListener('change', function (e) {
    if (e.target.name !== 'contact[Reason]') return;
    var form = e.target.closest('[data-ct-form]');
    if (form) sync(form);
  });

  document.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-ct-pick]');
    if (!pick) return;

    var radio = document.getElementById('ct-' + pick.dataset.ctPick);
    /* 这一页上没有表单那一节（运营删了），或者那条路的信箱没填 ——
       什么都不拦，让锚点自己去处理。拦下来会变成一颗点了没反应的按钮。 */
    if (!radio) return;

    radio.checked = true;
    var form = radio.closest('[data-ct-form]');
    if (form) sync(form);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* 编辑器里换设置会重画一整个 section —— 重画之后要再同步一次，
     否则刚加的那条路点了没反应。 */
  document.addEventListener('shopify:section:load', init);
})();
